import { Datagrid, LongTextField } from "ra-friendsofbabba";
import { EditButton, List as RaList } from "react-admin";

import Empty from "../component/list/Empty";
import Filters from "./Filters";
import React from "react";

const List = (props) => (
  <RaList
    {...props}
    empty={<Empty />}
    filters={<Filters />}
    sort={{ field: "Universities.name", order: "ASC" }}
    perPage={10}
  >
    <Datagrid rowClick="edit">
      <LongTextField source="university.name" sortBy="Universities.name" />
      <LongTextField source="name" sortBy="UniversityDepartments.name" />
      <EditButton />
    </Datagrid>
  </RaList>
);

export default List;
